'use client';

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

export default function PageLoader() {
  const [isVisible, setIsVisible] = useState(true);
  const topPanelRef = useRef<HTMLDivElement>(null);
  const bottomPanelRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Hide body overflow during loader
    document.body.style.overflow = 'hidden';

    // TEMPORARILY DISABLED: Check if we've already shown the loader (using sessionStorage)
    // const hasShownLoader = sessionStorage.getItem('pageLoaderShown');
    // if (hasShownLoader) {
    //   console.log('PageLoader: Already shown, hiding immediately');
    //   setIsVisible(false);
    //   document.body.style.overflow = '';
    //   return;
    // }

    // Mark that we've shown the loader
    // sessionStorage.setItem('pageLoaderShown', 'true');
    // console.log('PageLoader: Starting animation sequence');

    if (!topPanelRef.current || !bottomPanelRef.current) {
      // console.log('PageLoader: Refs not ready');
      return;
    }

    let exitTimer: NodeJS.Timeout | null = null;

    // Wait for next frame to ensure DOM is ready
    requestAnimationFrame(() => {
      if (!topPanelRef.current || !bottomPanelRef.current) return;

      // Set initial state - panels START at center (covering the page)
      gsap.set(topPanelRef.current, { y: 0 });
      gsap.set(bottomPanelRef.current, { y: 0 });

      // console.log('PageLoader: Starting 0.75-second wait timer');

      // After 0.75 seconds, animate panels away
      exitTimer = setTimeout(() => {
        // console.log('PageLoader: 0.75 seconds elapsed, starting exit animation');
        if (!topPanelRef.current || !bottomPanelRef.current) return;

        // Get the actual computed height of the panels (which use 50dvh) to match CSS
        // This ensures we use the same height value as the CSS, accounting for mobile browser UI
        const panelHeight = topPanelRef.current.offsetHeight;

        // Animate top panel up
        gsap.to(topPanelRef.current, {
          y: -panelHeight,
          duration: 0.8,
          ease: 'power2.inOut'
        });

        // Animate bottom panel down
        gsap.to(bottomPanelRef.current, {
          y: panelHeight,
          duration: 0.8,
          ease: 'power2.inOut',
          onComplete: () => {
            // console.log('PageLoader: Animation complete, hiding loader');
            setIsVisible(false);
            document.body.style.overflow = '';
          }
        });
      }, 750);
    });

    return () => {
      if (exitTimer) clearTimeout(exitTimer);
      document.body.style.overflow = '';
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div 
      ref={containerRef} 
      className="fixed inset-0 pointer-events-auto overflow-hidden" 
      style={{ 
        zIndex: 99999
      }}
    >
      {/* Top Panel */}
      <div
        ref={topPanelRef}
        className="absolute top-0 left-0 w-full bg-eggshell"
        style={{ height: '50dvh', zIndex: 100000 }}
      />

      {/* Bottom Panel */}
      <div
        ref={bottomPanelRef}
        className="absolute bottom-0 left-0 w-full bg-eggshell"
        style={{ height: '50dvh', zIndex: 100000 }}
      />

    </div>
  );
}
